import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const operations = {
  cancel: {
    title: 't(Pause/Cancel Subscription)',
    text: 't(Pause or cancel your subscription)'
  },
  payment_method: {
    title: 't(Change Payment Method)',
    text: 't(Change the card we have on file for your subscription)'
  },
  plan: {
    title: 't(Change Plan)',
    text: 't(Upgrade or downgrade your plan)'
  }
}

const OperationToken = ({ value }) => (
  <div className="token">
    <strong><T text={ operations[value].title } /></strong><br />
    <T text={ operations[value].text } />
  </div>
)

OperationToken.propTypes = {
  value: PropTypes.string
}

export default OperationToken
